import { render, staticRenderFns } from "./SQuesThirtyThree.vue?vue&type=template&id=1225c900&scoped=true&"
import script from "./SQuesThirtyThree.vue?vue&type=script&lang=js&"
export * from "./SQuesThirtyThree.vue?vue&type=script&lang=js&"
import style0 from "./SQuesThirtyThree.vue?vue&type=style&index=0&id=1225c900&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1225c900",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText})
